// extracted by mini-css-extract-plugin
export default {"option":"select_option__S0puv"};